import { Box } from "@mui/material";
import { isMobileOnly } from "react-device-detect";
import { FollowersNullSet } from "../nullSets/chatNullset";

const BookmarkedPostsTab = () => {
  return (
    <Box className={`inboxContentContainerEmpty ${isMobileOnly ? "mar-t-16" : "mar-t-24"}`}>
      <FollowersNullSet header="No bookmarks yet" body="Save posts to see them here" />
    </Box>
  );
};

export default BookmarkedPostsTab;
